<template lang="html">
  <div id="gps-btn" class="square-btn blue-text" :class="{'directions-gps': directionsGps}" aria-hidden="true" @click="toggleGps();">
    <span class="material-icons" v-show="!gpsCircle" :class="{'gps-blink': searchingForGps}">gps_not_fixed</span>
    <span class="material-icons" v-show="gpsCircle" :class="{'gps-blink': searchingForGps}">gps_fixed</span>
    <strong>GPS</strong>
  </div>
</template>

<script>
import TGPS from '@/assets/TinyGps.js'
import { EventBus } from '@/main.js'

export default {
  data() {
    return {
      gpsInUse: false,
      searchingForGps: false,
      gpsCircle: false,
    }
  },
  props: {
    directionsGps: {
      default: false,
    },
    map: {
      required: true,
    }
  },
  methods: {
    toggleGps() {
      /*if(!!TGPS.watchID) {
    		this.stopWatching();
    		return;
    	}*/
      if(this.gpsInUse) {
        this.stopWatching();
      }
      else {
        this.gpsInUse = true;
      	this.startWatching();
      }
  	},
  	startWatching() {
      this.searchingForGps = true;
  		if(!TGPS.watchID) {
  			TGPS.set({
  				onSuccess: () => {
            this.showGpsCircle();
          },
  				onError: (error) => {
            this.gpsError(error);
  				}
  			});
  			TGPS.watch();
  		}
  		else {
  			TGPS.takeOver(() => {
          this.showGpsCircle();
        });
  		}
  	},
    showGpsCircle() {
      var acc = this.$DeviceCheck.isIOS ? 15 : 50;
      if(TGPS.acc <= acc || !this.$DeviceCheck.isMobile) {
        this.searchingForGps = false;
      	var coordinates = TGPS.get();
      	if(!this.gpsCircle) {
      		var icon = L.divIcon({className: "gps-circle", html: '<div class="gps-circle-dot"></div>'});
      		this.gpsCircle = L.marker(coordinates, {icon: icon}).addTo(this.map.map);
          this.map.map.panTo(coordinates);
      	}
      	else {
      		this.gpsCircle.setLatLng(coordinates);
      	}
      }
    },
    stopWatching() {
      this.gpsInUse = false;
      this.searchingForGps = false,
    	TGPS.clearWatch();
      if(this.map.map.hasLayer(this.gpsCircle)){
    		this.map.map.removeLayer(this.gpsCircle);
    		this.gpsCircle = false;
    	}
    },
    gpsError(errorCode) {
      this.stopWatching();
    	switch(errorCode.code) {
    		//User denied
    		case 1:
          EventBus.$emit('openMessageBox', {message: 'GPS brug afvist af brugeren', btnText: 'Ok'});
    			break;
    		//Location unavailable
    		case 2:
    			EventBus.$emit('openMessageBox', {message: 'GPS lokation ikke tilgængelig.', btnText: 'Ok'});
    			break;
    		//Location timeout
    		case 3:
    			EventBus.$emit('openMessageBox', {message: 'GPS lokation kunne ikke tilgås.', btnText: 'Ok'});
    			break;
    	}
    },
  }
}
</script>

<style lang="css">
  #gps-btn, #user-group-map-gps-btn {
  	position: absolute;
    width: 36px;
  	padding: 2px;
  	margin-left: 0px;
  	z-index: 850;
  	bottom: 5px;
  	right: 4px;
    opacity: 1;
  	line-height: 12px;
    background-color: #f8f8f8;
    border: 1px solid #ddd;
    vertical-align: middle;
    text-align: center;
  	cursor: pointer;
  	box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  	-webkit-touch-callout: none; /* iOS Safari */
  	-webkit-user-select: none; /* Chrome/Safari/Opera */
  	-khtml-user-select: none; /* Konqueror */
  	-moz-user-select: none; /* Firefox */
  	-ms-user-select: none; /* Internet Explorer/Edge */
  	user-select: none; /* Non-prefixed version, currently not supported by any browser */
  	-webkit-backface-visibility: hidden;
  }

  #gps-btn strong, #user-group-map-gps-btn strong {
  	font-size: 11px;
  }

  #gps-btn.directions-gps {
    bottom: 50px;
  }

  @media screen and (min-width: 768px) {
    #gps-btn, #gps-btn.directions-gps {
      bottom: 80px;
    }
  }

  .gps-blink {
    animation: blinker 0.7s cubic-bezier(.5, 0, 1, 1) infinite alternate;
  }
  @keyframes blinker {
    to { opacity: 0; }
  }

  .gps-circle {
  	z-index: 800 !important;
  }

  .gps-circle-dot {
  	border-radius: 666px;
  	background-color: #a7172b;
  	height: 20px;
  	width: 20px;
  }

</style>
